<table *ngIf="crewList" class="width-100">
  <!-- Just for observable subscription -->
  @if (contactInfo$ | async) {
    <div></div>
  }
  <ng-container *ngFor="let crewMember of crewList; let i = index">
    <tr class="active">
      <td class="label-2 position">{{ crewMember.seat }}</td>
      <td class="name">
        <span class="font-medium"
          >{{ crewMember.nickname || crewMember.firstName || "" | titlecase }}
        </span>
        <!-- With first/nickname -->
        <span
          *ngIf="crewMember.firstName || crewMember.nickname"
          [class]="
            crewMember.name === 'OPEN'
              ? 'caution-color font-medium'
              : 'font-light'
          "
          >{{ crewMember.name }}</span
        >
        <!-- Without first/nickname -->
        <span
          *ngIf="!(crewMember.firstName || crewMember.nickname)"
          [class]="
            crewMember.name === 'OPEN'
              ? 'caution-color font-medium'
              : 'font-light'
          "
          >{{ crewMember.name }}</span
        >
      </td>
      <td *ngIf="crewLocation" class="text-xs">
        <div
          *ngIf="crewLocation[crewMember.employeeNumber]"
          class="contact-container"
          @fadeIn
        >
          <div
            *ngIf="crewLocation[crewMember.employeeNumber]['isFromHotel']"
            class="opacity-4"
          >
            Hotel
          </div>
          <div
            *ngIf="crewLocation[crewMember.employeeNumber]['isOrig']"
            class="opacity-4"
          >
            Seq orig
          </div>
          <div
            *ngIf="
              crewLocation[crewMember.employeeNumber]['isFromSameAircraft']
            "
            class="opacity-4"
          >
            Inbound flight
          </div>
          <div
            *ngIf="
              crewLocation[crewMember.employeeNumber]['arrivalFlight'] ===
              'UNKN'
            "
            class="opacity-4"
          >
            Unknown
          </div>
          <div
            *ngIf="
              !crewLocation[crewMember.employeeNumber]['isFromSameAircraft'] &&
              crewLocation[crewMember.employeeNumber]['arrivalFlight'] !==
                'UNKN' &&
              !crewLocation[crewMember.employeeNumber]['isFromHotel'] &&
              !crewLocation[crewMember.employeeNumber]['isOrig'] &&
              crewLocation[crewMember.employeeNumber]['arrivalFlight']
            "
          >
            <span class="opacity-4">Flight </span>
            <a
              [href]="
                getFlightAwareLink(
                  crewLocation[crewMember.employeeNumber]['arrivalFlight'] || ''
                )
              "
              target="_blank"
              class="link text-sm font-medium"
            >
              {{ crewLocation[crewMember.employeeNumber]["arrivalFlight"] }}
            </a>
          </div>
        </div>
      </td>
      <td rowspan="2">
        <div *ngIf="isPilot(crewMember)" class="contact-container">
          <div *ngIf="crewMember.history$ | async as history">
            <button
              mat-icon-button
              color="primary"
              (click)="onHistoryClick(crewMember)"
              [disabled]="history.isLoading"
              tabindex="-1"
              onclick="blur()"
            >
              <mat-spinner
                *ngIf="history.isLoading"
                diameter="24"
              ></mat-spinner>
              <mat-icon
                *ngIf="history.response && !history.isLoading"
                [class.success-color]="history.response.items.length > 0"
                [class.opacity-4]="history.response.items.length === 0"
                [class.warn-color]="history.response.items.length === 0"
                >history</mat-icon
              >
              <mat-icon
                *ngIf="!history.isLoading && !history.response"
                class="warn-color"
                >error_outline</mat-icon
              >
            </button>
          </div>
          <div>
            <button
              mat-icon-button
              (click)="onContactClick(crewMember, ContactType.Text)"
              color="primary"
              [disabled]="
                contactIsLoading(crewMember, ContactType.Text) ||
                (connectionStatus$ | async) === 'offline'
              "
            >
              @if (contactIsLoading(crewMember, ContactType.Text)) {
                <mat-spinner diameter="24"></mat-spinner>
              } @else {
                <mat-icon>sms</mat-icon>
              }
            </button>
          </div>
          <div>
            <button
              mat-icon-button
              (click)="onContactClick(crewMember, ContactType.Phone)"
              color="primary"
              [disabled]="
                contactIsLoading(crewMember, ContactType.Phone) ||
                (connectionStatus$ | async) === 'offline'
              "
            >
              @if (contactIsLoading(crewMember, ContactType.Phone)) {
                <mat-spinner diameter="24"></mat-spinner>
              } @else {
                <mat-icon>phonelink_ring</mat-icon>
              }
            </button>
          </div>
        </div>
      </td>
    </tr>
    <tr class="active">
      <td class="ffd">
        <div
          *ngIf="crewMember.fitForDuty === false"
          class="caution-color font-medium text-xs"
        >
          FFD
        </div>
      </td>
      <td class="numbers text-xs">
        <div class="no-wrap">
          <span class="font-bold">{{ crewMember.seniority || "" }}</span>
          <span *ngIf="crewMember.seniority" class="font-light"> | </span>
          <span class="font-light">{{ crewMember.employeeNumber || "" }}</span>
        </div>
        <div>
          <span
            *ngIf="crewMember.name && crewMember.base"
            class="font-light opacity-4"
          >
            ({{ crewMember.base || "" }})</span
          >
        </div>
      </td>
      <td *ngIf="crewLocation" class="text-xs">
        <div
          *ngIf="crewLocation[crewMember.employeeNumber]"
          class="contact-container"
          @fadeIn
        >
          <div
            *ngIf="
              !crewLocation[crewMember.employeeNumber]['isFromSameAircraft'] &&
              !crewLocation[crewMember.employeeNumber]['isFromHotel'] &&
              !crewLocation[crewMember.employeeNumber]['isOrig']
            "
          >
            <span
              class="font-bold"
              [class.success-color]="
                crewLocation[crewMember.employeeNumber]['arrivalStatus'] ===
                  'ON' ||
                crewLocation[crewMember.employeeNumber]['arrivalStatus'] ===
                  'IN'
              "
              [class.caution-color]="
                !(
                  crewLocation[crewMember.employeeNumber]['arrivalStatus'] ===
                    'ON' ||
                  crewLocation[crewMember.employeeNumber]['arrivalStatus'] ===
                    'IN'
                )
              "
            >
              {{ crewLocation[crewMember.employeeNumber]["arrivalStatus"] }}
            </span>
            <span class="opacity-4">
              {{
                crewLocation[crewMember.employeeNumber]["arrivalTime"] || ""
                  | time
              }}
            </span>
            <span class="opacity-4">
              {{ crewLocation[crewMember.employeeNumber]["arrivalGate"] }}
            </span>
          </div>
        </div>
      </td>
    </tr>
    <tr [class.active]="showSeqNumbers && crewMember.sequenceNumber">
      <td></td>
      <td colspan="2" class="text-xs">
        <div class="seq-num-container">
          <div class="font-light">Sequence</div>
          <div
            class="seq-button primary-color"
            (click)="onSeqClick(crewMember)"
          >
            {{ crewMember.sequenceNumber || "" }}
          </div>
        </div>
      </td>
    </tr>
  </ng-container>
  <tr *ngIf="shouldShowGroupText(crewList)" class="active">
    @if (groupTextInfo$ | async) {}
    <td colspan="3">
      <div class="contact-container group-sms">
        @if (groupTextIsLoading) {
          <button
            mat-stroked-button
            color="primary"
            class="save-button"
            (click)="onGroupTextClick(crewList)"
          >
            <mat-spinner diameter="24"></mat-spinner>
          </button>
        } @else {
          <button
            mat-stroked-button
            color="primary"
            class="save-button"
            (click)="onGroupTextClick(crewList)"
          >
            <mat-icon>group_add</mat-icon> Group Text
          </button>
        }
      </div>
    </td>
  </tr>
</table>
